import React from 'react';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import * as removeActions from "../actions/removeActions";
import {Link} from "react-router-dom";
import {PsRoutes} from "../../shared/routing/Routes";
import CompaniesTabTable from "../../shared/components/tabs/companies/CompaniesTabTable";
import Row from "../../shared/components/Row";
import Card from "../../shared/components/Card";
import CardBody from "../../shared/components/CardBody";
import Accordion from "../../shared/components/accordion/Accordion";
import {I18nUtils} from "../../../i18n/I18nUtils";
import Tab from "../../shared/components/Tab";
import AccordionItem from "../../shared/components/accordion/AccordionItem";
import Paginator from "../../shared/components/Paginator";
import RouterUtils from "../../shared/routing/RouterUtils";
import WorkersTabTable from "../../shared/components/tabs/workers/WorkersTabTable";
import MachinesTabTable from "../../shared/components/tabs/machines/MachinesTabTable";
import RemoveConfirmModal from "./RemoveConfirmModal";

const DEFAUL_STATE = {
  companiesPage: 1,
  workersPage: 1,
  machinesPage: 1,
  showConfirmModal: false,
};

class RemoveCardConfirm extends React.Component {

  constructor(init){
    super(init);

    this.state = DEFAUL_STATE;

    this.removeAction = this.removeAction.bind(this);
  }

  removeAction() {
    this.setState({ showConfirmModal: false });
    this.props.removeActions.remove(
      this.props.companies.map(company => company.id),
      this.props.workers.map(worker => worker.id),
      this.props.machines.map(machine => machine.id),
    );
  }

  renderAccordionCompanies(){
    if (this.props.companies.length > 0) {
      return (
        <AccordionItem
          id={'1'} accordionId={'export'}
          title={I18nUtils.tr('TR_SUBCONTRATAS').toUpperCase() + " (" + this.props.companies.length + ")"}
          expanded={false}
        >
          <Row clearfix={true}>
            <Tab>
              <CompaniesTabTable
                id={'REMOVE_CONFIRM_COMPANIES'}
                data={Paginator.buildData(this.props.companies, this.state.companiesPage, 10)}
              />
              <Paginator
                onPage={(page) => this.setState({companiesPage: page})}
                data={Paginator.buildPagerData(this.props.companies, this.state.companiesPage, 10)}
              />
            </Tab>
          </Row>
        </AccordionItem>
      );
    }
  }

  renderAccordionWorkers(){
    if (this.props.workers.length > 0) {
      return (
        <AccordionItem id={'2'} accordionId={'export'} title={I18nUtils.tr('TR_TRABAJADORES').toUpperCase() + " (" + this.props.workers.length + ")"} >
          <Row clearfix={true}>
            <Tab>
              <WorkersTabTable
                data={Paginator.buildData(this.props.workers, this.state.workersPage, 10)}
              />
              <Paginator
                onPage={(page) => this.setState({workersPage: page})}
                data={Paginator.buildPagerData(this.props.workers, this.state.workersPage, 10)}
              />
            </Tab>
          </Row>
        </AccordionItem>
      );
    }
  }

  renderAccordionMachines(){
    if (this.props.machines.length > 0) {
      return (
        <AccordionItem id={'3'} accordionId={'export'} title={I18nUtils.tr('TR_MAQUINARIA').toUpperCase() + " (" + this.props.machines.length + ")"} >
          <Row clearfix={true}>
            <Tab>
              <MachinesTabTable
                data={Paginator.buildData(this.props.machines, this.state.machinesPage, 10)}
              />
              <Paginator
                onPage={(page) => this.setState({machinesPage: page})}
                data={Paginator.buildPagerData(this.props.machines, this.state.machinesPage, 10)}
              />
            </Tab>
          </Row>
        </AccordionItem>
      );
    }
  }

  render() {
    return (
      <Row>
        <Card colWidth={'col-md-12'} loading={this.props.loading} >

          <CardBody>

            <Accordion id={'export'}>

              {this.renderAccordionCompanies()}
              {this.renderAccordionWorkers()}
              {this.renderAccordionMachines()}

            </Accordion>

            <div className="row">
              <div className="col-xs-6">
                <Link
                  to={RouterUtils.generateRoute(PsRoutes.MY_OUTSOURCES_PAPER_BIN_REMOVE)}
                  className={'btn btn-lg waves-effect waves-float'}
                >{I18nUtils.tr('TR_CANCELAR').toUpperCase()}</Link>
              </div>
              <div className="col-xs-6">
                <div className="text-right">
                  <a
                    className="btn btn-danger btn-lg waves-effect waves-float"
                    onClick={() => this.setState({ showConfirmModal: true})}
                  >{I18nUtils.tr('TR_ELIMINAR').toUpperCase()}</a>
                  <RemoveConfirmModal
                    show={this.state.showConfirmModal}
                    onHide={() => this.setState({ showConfirmModal: false })}
                    onAccept={this.removeAction}
                    countRemove={this.props.countRemove}
                  />
                </div>
              </div>
            </div>
          </CardBody>
        </Card>
      </Row>
    );
  }

}

const mapStateToProps = (state, ownProps) => {
  // Compañias
  let countRemoveCompanies = 0;
  const companies = state.remove.companies.map(company => {
    if (state.remove.companiesErrors[company.id]) {
      company.error = state.remove.companiesErrors[company.id];
    } else {
      countRemoveCompanies += 1;
    }
    return company;
  });
  // Trabajadores
  let countRemoveWorkers = 0;
  const workers = state.remove.workers.map(worker => {
    if (state.remove.workersErrors[worker.id]) {
      worker.error = state.remove.workersErrors[worker.id];
    } else {
      countRemoveWorkers += 1;
    }
    return worker;
  });
  // Maquinaria
  let countRemoveMachines = 0;
  const machines = state.remove.machines.map(machine => {
    if (state.remove.machinesErrors[machine.id]) {
      machine.error = state.remove.machinesErrors[machine.id];
    } else {
      countRemoveMachines += 1;
    }
    return machine;
  });

  return {
    loading: state.remove.loading,
    companies,
    workers,
    machines,
    countRemove: {
      company: countRemoveCompanies,
      worker: countRemoveWorkers,
      machine: countRemoveMachines,
    },
  }
};

const mapDispatchToProps = dispatch => ({
  removeActions: bindActionCreators(removeActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(RemoveCardConfirm)



// WEBPACK FOOTER //
// ./src/app/remove/components/RemoveCardConfirm.js